import QRCode from "qrcode";

export async function createPortalQrDataUrl(absoluteUrl: string): Promise<string> {
  return QRCode.toDataURL(absoluteUrl, {
    width: 320,
    margin: 2,
    errorCorrectionLevel: "M",
  });
}
